<script>
	import { shortcut } from './shortcut.js'
	import PixiCanvas from './PixiCanvas.svelte';
	import { COLORS, BANNER_NAMES, selected, currentBase, currentBlock, currentBanner, grid, infoText, drawingMode, showLayer, shiftDown, cDown, altDown, zDown } from './store.js';
	import Modal from './Modal.svelte';
	import sortedblocks from '../public/sortedblocks.json';
	import Switch from './Switch.svelte'
	import MaterialsList from './MaterialsList.svelte'
	import { clickOutside } from "./click_outside.js";

	let showMaterialList = false;
	let showHotkeys = false;
	let showAbout = false;
	let showExamples = false;
	
	let blocksList;
	let blocksListHeight = 0;

	let infoExpanded = false;

	let pixi;

	let key;


	function handleKeydown(event) {
		key = event.key;
		if(key === "Alt") {
			$altDown = true;
		}
		if(key === "c") {
			$cDown = true;
		}
		if(key === "Shift") {
			$shiftDown = true;
		}
		if(key === "z") {
			$zDown = true;
		}
	}

	function handleKeyup(event) {
		key = event.key;
		if(key === "Alt") {
			$altDown = false;
		}
		if(key === "c") {
			$cDown = false;
		}
		if(key === "Shift") {
			$shiftDown = false;
		}
		if(key === "z") {
			$zDown = false;
		}
	}

	/*
		WHAT: Change cursor position in the grid
		WHY: Function to change pos with arrow keys
	*/
	function handleMoveCursor(axis, amount) {
		if(axis === "x") {
			const newPos = $selected.x + amount;
			//clamp it from 0 to grid width
			$selected.x = Math.min(Math.max(parseInt(newPos), 0), $grid.width - 1)
		} else {
			const newPos = $selected.y + amount;
			//clamp it from 0 to grid height
			$selected.y = Math.min(Math.max(parseInt(newPos), 0), $grid.height - 1)
		}
	}

	/*
		WHAT: Change cursor position in the grid
		WHY: Function to change pos with arrow keys
	*/
	function handleChangePattern(type, amount) {
		if(type === 'pattern') {
			if($selected.pattern + amount < 1) {
				$selected.pattern = 41
			}
			if($selected.pattern + amount > 40) {
				$selected.pattern = 1
			}
			else {
				$selected.pattern += amount;
			}
		} 
		if(type === 'patterncolor') {
			if($selected.color + amount < 0) {
				$selected.color = 16
			}
			if($selected.color + amount > 15) {
				$selected.color = 0
			}
			else {
				$selected.color += amount;
			}
		}
		if(type === 'basecolor') {
			if($selected.base + amount < 0) {
				$selected.base = 16
			}
			if($selected.base + amount > 15) {
				$selected.base = 0
			}
			else {
				$selected.base += amount;
			}
		}
	}

	function handleWheel(event) {
		if($zDown) return;

		let amount;
		if(event.wheelDelta > 0) {
			amount = 1;
		} else {
			amount = -1;
		}

		if($drawingMode.pattern && !$cDown && !$shiftDown && !$altDown) {
			if($selected.pattern + amount < 1) {
				$selected.pattern = 41;
			}
			if($selected.pattern + amount > 40) {
				$selected.pattern = 1;
			}
			else {
				$selected.pattern += amount;
			}
		}
		if(($drawingMode.base && !$drawingMode.pattern && !$cDown && !$altDown) || ($shiftDown && !$cDown && !$altDown)) {
			if($selected.base + amount < 0) {
				$selected.base = 16;
			}
			if($selected.base + amount > 15) {
				$selected.base = 0;
			}
			else {
				$selected.base += amount;
			}
		}
		if($cDown) {
			if($selected.color + amount < 0) {
				$selected.color = 16
			}
			if($selected.color + amount > 15) {
				$selected.color = 0
			}
			else {
				$selected.color += amount;
			}
		}
		if($altDown) {
			if($selected.z + amount < 0) {
				$selected.z = 6
			}
			if($selected.z + amount > 5) {
				$selected.z = 0
			}
			else {
				$selected.z += amount;
			}
		}
		if($drawingMode.block && !$drawingMode.base && !$drawingMode.pattern && !$cDown && !$shiftDown && !$altDown) {
			if($selected.block + amount < 0) {
				$selected.block = sortedblocks.length;
			}
			if($selected.block + amount > sortedblocks.length - 1) {
				$selected.block = 0;
			}
			else {
				$selected.block += amount;
			}
			blocksList.scrollTop = $selected.block * 34 - blocksListHeight/2 + 34;
		}
	}
	function swapColors() {
		const tempColor = $selected.color;
		$selected.color = $selected.base;
		$selected.base = tempColor;
	}

	let prevColor;
	function pickBgColor() {
		if(!$currentBase) return;
		if($selected.color === $selected.base) {
			$selected.color = prevColor;
		} else {
			prevColor = $currentBanner?.color;
			$selected.color = $currentBase?.base;
		}
	}
	function eyeDropper() {
		if($currentBanner) {
			$selected.color = $currentBanner?.color;
		}
		if($currentBase) {
			$selected.base = $currentBase?.base;
		}
	}

</script>

<svelte:window on:keydown|preventDefault={handleKeydown} on:keyup|preventDefault={handleKeyup}/>


<main
	use:shortcut={{code: 'ArrowRight', callback: () => handleMoveCursor('x', 1)}}
	use:shortcut={{code: 'ArrowLeft', callback: () => handleMoveCursor('x', -1)}}
	use:shortcut={{code: 'ArrowUp', callback: () => handleMoveCursor('y', -1)}}
	use:shortcut={{code: 'ArrowDown', callback: () => handleMoveCursor('y', 1)}}

	use:shortcut={{control: true, code: 'ArrowRight', callback: () => handleChangePattern('pattern', 1)}}
	use:shortcut={{control: true, code: 'ArrowLeft', callback: () => handleChangePattern('pattern', -1)}}
	use:shortcut={{shift: true, code: 'ArrowUp', callback: () => handleChangePattern('basecolor', -1)}}
	use:shortcut={{shift: true, code: 'ArrowDown', callback: () => handleChangePattern('basecolor', 1)}}
	use:shortcut={{control: true, code: 'ArrowUp', callback: () => handleChangePattern('patterncolor', -1)}}
	use:shortcut={{control: true, code: 'ArrowDown', callback: () => handleChangePattern('patterncolor', 1)}}

	use:shortcut={{code: 'KeyX', callback: () => swapColors()}}
	use:shortcut={{shift: true, code: 'KeyX', callback: () => pickBgColor()}}
	use:shortcut={{code: 'KeyI', callback: () => eyeDropper()}}


>
	<div class="nav">
		<div class="logo">BANNERMODE <small>modular Minecraft banner art -editor</small></div>
		<div>
			<button on:click|preventDefault="{() => showMaterialList = true}">
				Show material list
			</button>
			<button on:click|preventDefault="{() => showHotkeys = true}">
				Show hotkeys
			</button>
			<button on:click|preventDefault="{() => showExamples = true}">
				Show examples
			</button>
			<a href="https://www.reddit.com/r/bannermode/" target="_blank" rel="noreferrer nofollow">
				<button>r/bannermode</button>
			</a>
			<button on:click|preventDefault="{() => showAbout = true}">
				Show about
			</button>
		</div>
	</div>
	
	<div class="tb_patternpicker">
		<div class="tb_pattern-list">
			{#each {length: 40} as _, i}
				<div 
					class="tb_base"
					style="--bg-pos: -0px -{7 * 40}px;"
					on:click={() => $selected.pattern = i+1}
				>
					<div 
						class="tb_banner {i+1 === $selected.pattern ? 'selected' : ''}"
						style="--bg-pos: -{(i+1) * 20}px 0px;"
						on:mouseenter={() => $infoText = `${$BANNER_NAMES[i+1].name} / "${$BANNER_NAMES[i+1].ingame}"`}
						on:mouseleave={() => $infoText = ""}
					></div>
				</div>
			{/each}
		</div>
	</div>

	<div class="tb_blocks">
		<div class="tb_header"><small>Block</small></div>
		<div class="tb_blocks-list custom-scrollbar" bind:this={blocksList} bind:clientHeight={blocksListHeight}>
			{#each sortedblocks as {name, frame}, i}
				<div
					class="tb_block tooltip-right {i === $selected.block ? 'selected' : ''}"
					on:click={() => $selected.block = i}
					on:mouseenter={() => $infoText = `${name.replace(/\b\w/g, l => l.toUpperCase())}`}
					on:mouseleave={() => $infoText = ""}
				>
				<div 
					class="tb_block-sprite"
					style="--bg-pos: -{frame.x}px 0px;"
				></div>
				</div>
			{/each}
		</div>
	</div>


	<div class="tb_basecolor-picker">
		<div class="tb_header"><small><abbr title="Banner color">BG</abbr></small></div>
		{#each $COLORS as {name, hex}, i}
			<div
				class="tb_colorbox tooltip-right {i === $selected.base ? 'selected' : ''}"
				style=" background-color: {hex}"
				on:click={() => $selected.base = i}
				on:mouseenter={() => $infoText = name}
				on:mouseleave={() => $infoText = ""}
			>
			</div>

		{/each}
	</div>


	<div class="tb_patterncolor-picker">
		<div class="tb_header"><small><abbr title="Pattern color">Pat</abbr></small></div>
		{#each $COLORS as {name, hex}, i}
			<div
				class="tb_colorbox tooltip-left {i === $selected.color ? 'selected' : ''}"
				style="background-color: {hex}"
				on:click={() => $selected.color = i}
				on:mouseenter={() => $infoText = name}
				on:mouseleave={() => $infoText = ""}
			>
			</div>
		{/each}
	</div>

	<div class="canvas_container" on:wheel={handleWheel} >
		<PixiCanvas bind:this={pixi}/>
	</div>

	<div class="tb_layers">
		
		<div class="infoText">
			<div class="infoText-wrapper {infoExpanded ? 'expanded' : ''}">
				<div class="infoText-header">
					<small>INFO</small>
					<button aria-checked={infoExpanded} on:click={() => infoExpanded = !infoExpanded}>{infoExpanded ? "▂▂" : "▄▄"}</button>
				</div>
				<div class="infoText-content custom-scrollbar">

					x:{$selected.x + 1} y:{$selected.y + 1}<br/>

					{#if $infoText !== ""}
						{$infoText}
					{/if}

					{#if $grid.banners.has('bl|' + $selected.x + '|' + $selected.y)}
						→ {sortedblocks[$grid.banners.get('bl|' + $selected.x + '|' + $selected.y).block].name}<br/>
					{/if}

					{#if $grid.banners.has($selected.x + '|' + $selected.y)}
						→ {$COLORS[Number($grid.banners.get($selected.x + '|' + $selected.y).base)].name} banner<br/>
					{/if}
					
					{#each {length: 6} as _, i}
						{#if $grid.banners.has($selected.x + '|' + $selected.y + '|' + i)}
							→ {$COLORS[Number($grid.banners.get($selected.x + '|' + $selected.y + '|' + i).color)].name}
							{$BANNER_NAMES[Number($grid.banners.get($selected.x + '|' + $selected.y + '|' + i).pattern)].name}<br/> 
						{/if}
					{/each}
				</div>
			</div>
		</div>

		<div class="tb_layers-list">


			{#if !!$currentBlock !== false}
				<div 
					class="tb_block tb_block-wrapper"
				>
					<span class="small-heading">Block</span>
					<div 
						class="tb_block-sprite"
						style="--bg-pos: -{sortedblocks[$currentBlock.block].frame.x}px 0px;"
					>
					</div>
				</div>
			{:else}
				<div class="tb_block tb_block-wrapper"><span class="small-heading">Block</span></div>
			{/if}
		
			<span class="layer_arrow">→</span>

			{#if !!$currentBase !== false}
				<div 
					class="tb_base"
					style="--bg-pos: -0px -{$currentBase?.base * 40}px;"
				>
					<span class="small-heading">BG</span>
				</div>
			{:else}
				<div class="tb_baseEmpty"><span class="small-heading">BG</span></div>
			{/if}
			
			<span class="layer_arrow">→</span>

			{#each {length: 6} as _, i}

				{#if $grid.banners.has($selected.x + '|' + $selected.y + '|' + i)}
					<div 
						class="tb_base"
						style="--bg-pos: -0px -{7 * 40}px;"
						on:click={() => $selected.z = i}
					>
						<span class="small-heading">{i+1}</span>
						<div 
							class="tb_banner {i === $selected.z ? 'selected' : ''}"
							style="--bg-pos: -{$grid.banners.get($selected.x + '|' + $selected.y + '|' + i).pattern * 20}px 0px;"
						></div>
						<div class="tb_banner-color" style="background-color: {$COLORS[$grid.banners.get($selected.x + '|' + $selected.y + '|' + i).color].hex}"></div>
					</div>
				{:else}
					<div 
						class="tb_baseEmpty {i === $selected.z ? 'selected' : ''}"
						on:click={() => $selected.z = i}	
					>
						<span class="small-heading">{i + 1}</span>
					</div>
				{/if}
				{#if i < 5} 
					<span class="layer_arrow">→</span>
				{/if}

			{/each}
		</div>

		<div class="tb_buttonbox modes">
			<span class="small-heading">Drawing Modes</span>
			<Switch bind:checked={$drawingMode.block} label="Blocks" design="inner" />
			<Switch bind:checked={$drawingMode.base} label="Banners" design="inner"/>
			<Switch bind:checked={$drawingMode.pattern} label="Patterns" design="inner" />
		</div>

		<div class="tb_buttonbox modes">
			<span class="small-heading">Display</span>
			<Switch bind:checked={$showLayer.block} label="Blocks" design="inner" falseText="no" trueText="yes" />
			<Switch bind:checked={$showLayer.banner} label="Banners" design="inner" falseText="no" trueText="yes"/>
		</div>

		<div class="tb_buttonbox save">
			<span class="small-heading">Save & export </span>
			<div><button on:click={() => pixi.saveAsFile()}>Save</button>
			<button on:click={() => pixi.loadFromFile()}>Load</button></div>
			<button on:click={() => pixi.handleExportAsPng()}>Export PNG…</button>
		</div>

		<div class="tb_buttonbox history">
			<span class="small-heading">Undo / redo</span>
			<button on:click={() => pixi.commands.undo()}>Undo</button>
			<button on:click={() => pixi.commands.redo()}>Redo</button>
			<button on:click={() => pixi.doTimelapse("run")} on:outclick={pixi.doTimelapse("stop")} use:clickOutside>timelapse</button>
		</div>

		<div class="tb_buttonbox canvasSize">
			<span class="small-heading">Size</span>
			<button class="size_button1" on:click={() => pixi.handleGridSize(-1, 0)}>←</button>
			<button class="size_button2" on:click={() => pixi.handleGridSize(1, 0)}>→</button>
			<button class="size_button3" on:click={() => pixi.handleGridSize(0, -1)}>↑</button>
			<button class="size_button4" on:click={() => pixi.handleGridSize(0, 1)}>↓</button>
		</div>

	</div>

	{#if showHotkeys}
		<Modal on:close="{() => showHotkeys = false}">
			<h2 slot="header">
				Hotkeys
			</h2>
			<ul class="hotkeys">
				<h3>Mouse</h3>
				<li><kbd>left click</kbd> <span>insert</span></li>
				<li><kbd>right click</kbd> <span>use pattern</span></li>
				<li><kbd>shift</kbd> + <kbd>scroll</kbd> <span>select base (BG) color</span></li>
				<li><kbd>scroll</kbd> <span>select pattern</span></li>
				<li><kbd>c</kbd> + <kbd>scroll</kbd> <span>select pattern (FG) color</span></li>
				<li><kbd>alt</kbd> + <kbd>scroll</kbd> <span>select pattern layer</span></li>
				<li><kbd>z</kbd> + <kbd>drag or scroll</kbd> <span>pan & zoom</span></li>
			</ul>
			<ul class="hotkeys">
				<h3>Keyboard</h3>
				<li><kbd>q</kbd> <span>insert</span></li>
				<li><kbd>up/down/left/right</kbd> <span>move around</span></li>
				<li><kbd>ctrl</kbd> + <kbd>left/right</kbd> <span>select pattern</span></li>
				<li><kbd>number keys</kbd> <span>select pattern layer</span></li>
				<li><kbd>shift</kbd> + <kbd>number keys</kbd> <span>swap pattern layers</span></li>
				<li><kbd>shift</kbd> + <kbd>up/down</kbd><span>select base (BG) color</span></li>
				<li><kbd>ctrl</kbd> + <kbd>up/down</kbd> <span>select pattern (FG) color</span></li>
				<li><kbd>shift</kbd> + <kbd>x</kbd> <span>swap base and pattern colors</span></li>
				<li><kbd>x</kbd> <span>pick color from base</span></li>
				<li><kbd>i</kbd> <span>pick colors from selected</span></li>
				<li><kbd>space</kbd> <span>remove pattern</span></li>
				<li><kbd>shift</kbd> + <kbd>space</kbd> <span>empty space</span></li>
				<li><kbd>ctrl</kbd> + <kbd>z</kbd> <span>undo</span></li>
				<li><kbd>ctrl</kbd> + <kbd>shift</kbd> + <kbd>z</kbd> <span>redo</span></li>
				<li><kbd>ctrl</kbd> + <kbd>shift</kbd> + <kbd>s</kbd> <span>save as</span></li>
				<li><kbd>ctrl</kbd> + <kbd>e</kbd> <span>export as png</span></li>
				<li><kbd>ctrl</kbd> + <kbd>c</kbd> <span>copy</span></li>
				<li><kbd>ctrl</kbd> + <kbd>v</kbd> <span>paste</span></li>
				<li><kbd>b</kbd> <span>toggle block drawing mode</span></li>
				<li><kbd>n</kbd> <span>toggle banner drawing mode</span></li>
				<li><kbd>m</kbd> <span>toggle pattern drawing mode</span></li>
			</ul>
		</Modal>
	{/if}
	{#if showExamples}
		<Modal on:close="{() => showExamples = false}">
			<h2 slot="header">
				Examples
			</h2>
			<p>Here's a few examples I made that hopefully shows the potential of this tool and inspires you to try to make something yourself!</p>
			
			<h4>Dog</h4>
			<video 
				src="./example-dog.m4v"
				controls>
				<track kind="captions">
			</video>
			<p>Recreated in game:</p>
			<img src="./example-dog-ingame.jpg" alt="Face of a derpy brown dog made with minecraft banners">
			<p>
				<a href="https://bannermo.de/?w=10&h=9&c=NrCMBoIgOBddgCZIoAzke0j5JVcATnDgWQOWhN3JQGYNjRcJbS9b1EmXwB2FO2QCIXHghiCaJNI0i8AbFLLgloucxW0IAVkg4tKZABZ902g0RQDYcA2u9TDieD3O8a%2BmZWfkam8j24FxuOtJBUHp80m7BGKEx%2BJCm0SpByIj%2BiawYWSpOcYhOYflJdFg2FNQqOVD2lV5CXrUNApTSbYUVHRj4DOyS7S5U-bxUpgMyepNUSpMQE7wCc0uu1ba66wQrLgKju%2BCLLhnetpanC73YvHrkDUp3vIEXdq-XLqYMCjdv979PhxeDCcDVMxR%2BIMUgPetmQbgaDHhjjW3xceiRLiUGNhqiBuJhlzytj0RIgSiJtFMXFOlKMMGkmy43RqawgxCaZJQkJUe2aAX4gPQdEiPQKdG5eAEpmeMOEaywVFAJUlrPw-IEtzs2LlenOTWlXUgypMVwwEpNJ24-HCvS4UBtFgSaV6GQYqAda0wNNeJuFRo99m1nsK9pUmogdCdeE1ruCiV9IrDvVuzLwn0NssB6WIqTTPrs4NKDEsfkSbsgOZt5dAVFzzwi3t1Rm9YLioGW0lbLU7gO0-NMei45GMPdioC%2Bo5dqZNTcyjfluX9SdiXqV5ltb2NvWr5C3JoqS44C9Xe9NTH5MoL3rhSUzwIzW8RcXKh78C7UW6UVMgWE-rywv7SA8cQfkBprjt6X70OarwFI8zpjkwj69pA9RgbEgbrkoYivq82EaFupj4Vaa5JsRSFgeRuFvhG3pfHylFXNMPaeCIW4koIuFPicmbouB-J6N%2BoAQHWawFOeuDoOgIjCpJIH6COCBSayRRyegIKKcAyn1Jpyl3LpbaoZoWmyOOxnUhUBk7gZQmqUpC7YAZ%2BGOXJAiWXJVBYLJ9lMEZcnEPp-m-AZxAaUF8IhfidkmTmfn2ZIZlyZQClyf0KX2RM6UmdMWXoHMuUCoq0XoFQireSZynjnQakyFVQVldVPltnQjUmXK45WQK465tSajiql%2BL9fZT4dUlrJDW10ITVgXXTYCbhzURqE2VNnVOHNxbLWN9hzTxG1XPtdQrUdckGqN9nhnNY6LW8dA9WsO0GYJW0XeNT2DU5H1yViL0mVB51-bdn3kHNngA9JQOuatUMLQZyy-eps33VEqH3UoMlwwKCjsCVWM4zI5L41QJJE4C2MeXhpN%2BKTUB8KiJkiJAdNQ9TY20-TM3s3JtRzbR4NcgjKCw9zX2wEAA" target="_blank">
					Open this example
				</a>
			</p>

			<h4>Monastery</h4>
			<img src="./example-monastery.png" alt="Monastery wall made with minecraft banners">
			<p>Recreated in game:</p>
			<img src="./example-monastery-ingame.jpg" alt="Monastery wall made with minecraft banners in game">
			<p>
				<a href="https://bannermo.de/?w=14&h=10&c=NrCMBoFZwZnVIF1zAExVuADOVA2bZMcAdkwSPTLh30JQmnQofAPQA4iIzmkV0TbLgJZu4ACzxwXVtAiziBBeLIrWHaYqq5hdMQNK6F9NBmYzTg3elR9KGCLTIlxUnK9ZTObzIohSUv4YQeIEoawEcMGaPhp+4poRxGTJOra49oZSNLguDt56+dnSzqQOykXlhuxVnmZRdRWSTYbQ7nnVZoGtKRj1OtBlA0YdqMXEmtAjU72cLcMOmrnjXfPoi4Zqc5ZOnfUQBNPNQ-vi0MdtGJvEUpfd12dXUhCr2qPSbwXSr2Tvhb8ZN84ID-i1Qd95J13hdPn9mi9oSc4UCto4kYZZhDMeCMWZlij3rFCUsfnidBBsQ0yV8asZyWxyAyoVTrIVUABONYfWxckYdMqgCTfHCvLmgVDnYQjU6C4WRaXNHBy1SKtHKzpCxJq-HCFVXUW4cWSumGznwE1mMhm42km0WkU2TQsMynWzO-jU2i4D0Oa1O+Ce+be1C+ko4OCoeRBx6R6NKzBRwN+4Rx5M4iO4eMlV5G7lQ3ncyqFkbbEuk3Pm-nSaL5muWEaVWul+uaGat7mpPx1nIN8Rc+SW9ADvRhswj17Oy0QLkvIfgWej9Pj3Ghh2sLnRByb3oz3TvLkbJ7EUDe96n3Q3SmZ8+Zq-wHBpB8LY-X-oOC9uiaUxjc0C-+9-xac8Al3eAIC3QwgJWb9wP3D9c3vSNl3QZDaFEcQ4BBT0IOAhw4DGWC4HuVDHlWA5dBIyiwPQJ9aJohJDFI+8MneDIbmHJlaRXCxuOYb1WWfEEGQvRE+OfAt4Sg39BKAsSpLMaCSWk+lxOI5SzGsQT6MEgiNIyYTxIyQSR34lCFxaMyXU46BI2w7cWm8cUY0XaAp3EICPAQvVNXlRS9jTay4PtCV+x1TiNVWLVWAvLyoI1fViCPEYj0S3C4rMXJEvYz5bUMXIxXXFcQvnWLcqKnL3XMlYfXMrkQzHMyGvMo9ApjXI2oczMkyCsrOo3LQHL2ciPMNW9SlfOD1H8iaRtYCw2NmojBvypbuXFfTn0pETtu0mkFNI7bxI28t4s+PMRiAys+QcXiLvw86q1ujsRmE5shu7S7DXelTcLbcR0COZ7RFq0AYGBz4pkwxl2sZWhnXBrwYe+EG1zBqUgauVGEbCZG6Wx+BEb6TGrTh0GiZMEn5gJ9GYpwKnnxpim4IZoCmY8ngoG8-0ruZoCoZUzR4cJ0bLBjC8hfJsKyBcoxhdpyYxdJSW0eZrkBZXFWcbpoxxY8JcFZMGXSX9VXVQ1nQtZFhVjbpU3tb6W3SZ5ylmYIC3GStw3+i5q57et24lZKL3mbc33XUsUVXd8J36P973a1hkOAaDzTI6l+bdee+PmbgWPMBdgOMjLD285rZQidI4sPakavw8BxlJ3ryw671xvavFznXlFSuMFb5oS+bsh+7RbYYAr75B5jNtIebsPu6LoxnQ75XZ9lqeHGmNeP31pvO-btc2+Xw-vOPj31e3ukz+boJL8y3YV6Yh+T6f2pzVC1a37yh4v4qvubG-g3X+H9SbAPnJoMBO9GSFhAcwQ4AC-4zz0rAiy1AfjgMsMhFBF8sJ-z5AglBmhiTv3nBfVCop5zWHmCg9S1D5ywjoZCfcf8jjMJQTLNhGChDuTOtwv+QE+E0MwOhKwiYtCiOQrYLI992Q3VWr2f6OIkgWjwR8C8IC9wEBGFyEGg4HLFmcs9Wy8A1Cw2MaAUxTCQSWKuOYmx1I7HmQ4dY8yswXG9RwI43qv53ExjZCYv+6kXhqHnHccEITN4hACSg1hwS-4cLiYQqJFj+GePCfw38iT5xlyqgrUiaCX73y7KgSkfl8nmDgHgSJxCHbWAJIUuplkAjVIqfAFMvAM7O0TB7FwTS2DtNaaVTmuTe5AQKR7MZfToozQ4agEE3lmoum9MqIgd5TCPj1Ksx4BhgD002SgfWKyDnpx2Tgeq6znxHN2cFC5V1bmGlORZJwWzl6PO2I8yojyoSPMRI84SjyLAAuMBIKpxysEgq2QCCFxzahClBdcoQcKtkdKRcc4kqLrmHngNC65h0YCem9C8fFWytLErBeQHFmYXiUswPIMl1ywlgwJY5QmzLexMq2eYml7RsXwrSXS5lrCOUwvBPSvZIIxVGBBDSrsGL9YCpeY4SVyjhXXIJKqs55BJWLg1RZeQNLPysq2aJI1xyLwSuZReZgBrcxyrgha41oFdUCNNdctmrrRR7N1To3liqK7MuHh6xk-rIWN0lZUoNDddXQBDcc9IWBLSZl4Am0NybE0+1QCmkVabkVGEzemmeYM-KerzVmt1wyy1R12ByS1OBnQ1q2fgotjbdgwGLZYBG7a-i4ErZ7HtoBOXVrZZYTNA7yX1uZesLAY7cVPIbeSw807Q3innQiiyo6tkEBXQG9dvbNDijbS2g97aLyLvTUBM9iBEBAA" target="_blank">
					Open this example
				</a>
			</p>

			<h4>Flowers (in game)</h4>
			<img src="./example-flowers.jpg" alt="Girl in a flower field made with minecraft banners">

			<h3>Share yours!</h3>
			<p>If you make something nice, share it with others in the <a href="https://www.reddit.com/r/bannermode/" target="_blank" rel="noreferrer nofollow">r/bannermode</a> subreddit</p>
		</Modal>
	{/if}

	{#if showAbout}
		<Modal on:close="{() => showAbout = false}">
			<h2 slot="header">
				What is Bannermode?
			</h2>
			<p>Bannermode is a web-based editor that makes it easy to design large and complex Minecraft banner compositions. Bannermode lets you change patterns and color combinations quickly and efficiently, making experimenting with banners a lot easier, faster and more fun.</p>
			<p>Remake your banner creations in Minecraft; place them on a wall as a "paintings" or use them as a backdrops for your "film studio". Possibilities are endless! :)</p>
			<p>Your creations are saved in the "url" automatically, which also means that you can share them with others by sharing the link! I made a subreddit for this purpose too: <a href="https://www.reddit.com/r/bannermode/" target="_blank" rel="noreferrer nofollow">r/bannermode</a></p>
			<h3>
				Copyright & Licence
			</h3>
			<p>
				BANNERMODE IS NOT AN OFFICIAL MINECRAFT PRODUCT. BANNERMODE IS NOT APPROVED BY OR ASSOCIATED WITH MOJANG.
				"Minecraft" is a trademark of Mojang AB. Banner & block textures are copyrighted and owned by Mojang.
			</p>
			<p>
				Bannermode is free for anyone to use.<br/>
				Creations made using this software and art featured in this software can NOT be used for anything relating to or containing non-fungible tokens (so-called "NFT") or blockchain (related) projects.<br/>
				If you make something cool and share it, a mention of this site is greatly appreciated, but not mandatory.
			</p>
			<p>
				Fonts "jgs5" and "jgs9" used on this site are created by <a href="https://www.adelfaure.net/" target="_blank" rel="noreferrer nofollow">Adel Faure</a> and licensed under the <a href="https://www.adelfaure.net/builds/jgs/LICENSE" target="_blank" rel="noreferrer nofollow">SIL Open Font License 1.1.</a>
			</p>
			<h3>Contact</h3>
			<p>
				Bannermode is made by Heikki Lotvonen.<br />
				If you find any bugs, have feature suggestions or something else, don't hesitate to contact me!
				You can find me on <a href="https://www.instagram.com/heikkiveikko/" target="_blank" rel="noreferrer nofollow">Instagram</a> and <a href="https://twitter.com/GlyphDraw" target="_blank" rel="noreferrer nofollow">Twitter</a> and you can email me at hlotvonen@gmail.com.<br/>
				I've also made other modular design tools, such as <a href="https://glyphdrawing.club/">Glyph Drawing Club</a>. Check it out!
			</p>

		</Modal>
	{/if}
	{#if showMaterialList}
		<Modal on:close="{() => showMaterialList = false}">
			<h2 slot="header">
				Materials list
			</h2>
			<MaterialsList />
		</Modal>
	{/if}

</main>

<style>
	main {
		background-color: #333;
		color:#eee;
		height: 100%;
		width: 100%;
		
		display: grid; 
		grid-template-columns: min-content 0.1fr 2.8fr 0.1fr; 
		grid-template-rows: 0.1fr 0.2fr 4.4fr 0.2fr; 
		grid-template-areas: 
			"nav nav nav nav"
			"blocks basecolor patterns patterncolor"
			"blocks basecolor canvas patterncolor"
			"blocks basecolor tb_layers patterncolor"; 
	}
	.nav { grid-area: nav; }
	.tb_patternpicker { grid-area: patterns; }
	.tb_patterncolor-picker { grid-area: patterncolor; }
	.tb_basecolor-picker { grid-area: basecolor; }
	.canvas_container { grid-area: canvas; }
	.tb_layers { grid-area: tb_layers; }
	.tb_blocks { grid-area: blocks; }


	.nav { 
		background-color: #666;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #666;
		padding:2px;
	}
	.logo {
		letter-spacing: 1px;
	}
	.tb_basecolor-picker { 
		display: flex;
		flex-direction: column;
		padding:4px;
	}
	.tb_colorbox {
		flex:1;
		box-shadow: 0px 0px 0px 1px #666;
		width:100%;
	}
	.tb_patterncolor-picker { 
		display: flex;
		flex-direction: column;
		padding:4px;
	}
	.tb_patternpicker {
		padding: 8px 0;
		border-bottom: 1px solid #666;
	}
	.infoText {
		position:relative;
		width: 20%;
		height: 54px;
		box-shadow: 0px 0px 0px 1px #666;
	}
	.infoText-wrapper {
		width:100%;
		height:100%;
	}
	.infoText .expanded {
		position:absolute;
		height: auto;
		bottom:0;
		min-height: 100%;
		box-shadow: 0px 0px 0px 1px #666;
		width: 100%;
		background-color: #333;
	}
	.infoText-header {
		font-family: 'jgs5', monospace;
		font-size: 0.5rem;
		text-transform: uppercase;
		position: absolute;
		top: -12px;
		left: 0px;
		width: 100%;
		letter-spacing: 1px;
		display: flex;
		justify-content: space-between;
	}
	.infoText .expanded .infoText-header small, 
	.infoText .expanded .infoText-header button {
		background-color: #333;
	}
	.infoText-header button {
		background-color: #333;
		color:#999;
		border:0;
		padding:0;
		line-height: 1;
		letter-spacing: 0;
		border:1px solid #666;
	}
	.infoText-content {
		height: 100%;
		overflow: auto;
		font-family: 'jgs5', monospace;
   		font-size: 10px;
		letter-spacing: 1px;
		text-transform: uppercase;
		line-height: 1.4;
		padding:2px;
	}
	.tb_buttonbox {
		position:relative;
		display: flex;
		gap:4px;
		padding:8px;
		box-shadow: 0px 0px 0px 1px #666;
		margin-right: 8px;
	}
	.tb_buttonbox.modes {
		align-items: end;
	}
	.tb_buttonbox.save {
		flex-direction: column;
	}
	.tb_buttonbox.canvasSize {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(2, 1fr);
		grid-column-gap: 0px;
		grid-row-gap: 0px;
	}

	.tb_buttonbox button {
		flex:1;
		background-color: #666;
		color:#eee;
	}
	.tb_buttonbox.history {
		flex-wrap: wrap;
		max-width: 100px;
	}
	.tb_layers {
		display:flex;
		justify-content: center;
		padding: 16px 0 8px;
		border-top: 1px solid #666;
	}
	.tb_layers-list {
		display: flex;
		flex-wrap: wrap;
		height: 100%;
		gap:2px;
		padding:0 8px;
	}
	.layer_arrow {
		padding-top:8px;
	}
	.tb_blocks {
		padding: 4px 0 4px 4px;
		display: flex;
		flex-direction: column;
	}
	.tb_blocks-list {
		direction:rtl;
		width:44px;
		display: flex;
		flex-wrap: wrap;
		gap:2px;
		overflow: auto;
		height: 100%;
		padding: 2px;
		margin-top:-2px;
	}
	.tb_block {
		height: 32px;
		width: 32px;
		position: relative;
	}
	.tb_block-sprite {
		background-image: url(../blocks.png);
		background-position: var(--bg-pos);
		position:absolute;
		top:0;
		left:0;
		height: 16px;
		width: 16px;
		transform: scale(2);
		transform-origin: top left;
		image-rendering: pixelated;
	}
	.tb_pattern-list {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		height: 100%;
		justify-content: center;
		gap:2px;
		align-items: center;
	}
	.tb_banner {
		background-image: url(../banners.png);
		background-position: var(--bg-pos);
		position: absolute;
		height: 100%;
		width:100%;
		top:0;
		left:0;
	}
	.tb_banner-color {
		position: absolute;
		bottom:-14px;
		left: 0px;
		height: 8px;
		width:20px;
		box-shadow: 0px 0px 0px 1px #666;		
	}
	.tb_base {
		position: relative;
		background-image: url(../banners.png);
		background-position: var(--bg-pos);
		width:20px;
		height:40px;
	}
	.tb_baseEmpty {
		position: relative;
		width:20px;
		height:40px;
		box-shadow: 0px 0px 0px 1px #666;
		background-color: #464e52;
	}
	.tb_block-wrapper {
		box-shadow: 0px 0px 0px 1px #666;
		background-color: #464e52;
		width:32px;
		height:32px;
		position:relative;
	}
	.tb_header {
		text-align: center;
	}
	.canvas_container { 
		overflow:hidden;
	}
	.selected {
		box-shadow: 0px 0px 0px 2px red;
		z-index: 1;
	}

	.hotkeys {
		padding:0;
		list-style:none;
	}
	.hotkeys li {
		display: flex;
		align-items:end;
		padding:2px 2px 4px;
	}
	.hotkeys span {
		text-align: right;
		flex:1;
		border-bottom: 1px dashed #999;
	}

</style>